module.exports = __webpack_public_path__ + "img/l3.acf7b783.png";